import React, { useEffect } from 'react';

import PropTypes from 'prop-types';
import { useForm, FormProvider } from 'react-hook-form';
import { isEmpty } from 'ramda';
import ToolsRepository from 'repositories/ToolsRepository';

import Popup from 'components/Popup';

import { useReportTask } from 'hooks/api/useReportTask';
import { useSnackbar } from 'hooks/useSnackbar';
import { useErrors } from 'hooks/useErrors';

import { reportActions } from 'utils/reports';

import DatePicker from './components/DatePicker';
import useStyles from './useStyles';
import { resolver, formField, prepareForSend } from './validation.js';

const TITLE = 'Funding Request';
const SUCCESS = 'Successfully Generated';

const FundingRequestPopup = props => {
  const classes = useStyles();
  const { setPopupState } = props;
  const { initiateTaskReportLoading, isTaskReportLoading, finishLoading, resetReportTask } =
    useReportTask();

  const { formatErrors, setErrorsToForm, displayErrorsInToast } = useErrors();
  const { showSuccessNotification } = useSnackbar();

  const methods = useForm({
    resolver,
    defaultValues: {
      [formField.fieldKey]: new Date(),
    },
    shouldFocusError: true,
    mode: 'onSubmit',
  });

  const { setError, errors } = methods;

  useEffect(() => () => resetReportTask(), []);

  const handleImportClose = () => {
    setPopupState(null);
  };

  const fetchReportLocation = data => () => {
    const fundingDate = prepareForSend(data);
    return ToolsRepository.fundingRequestReport(fundingDate);
  };

  const handleImportSubmit = async data => {
    const toastText = `${TITLE} ${SUCCESS}`;
    const fetchLocation = fetchReportLocation(data);
    try {
      const href = await initiateTaskReportLoading(fetchLocation);
      await reportActions.download(href);
      showSuccessNotification(toastText);
      handleImportClose();
    } catch (reportErrors) {
      if (!isEmpty(reportErrors)) {
        const { backendServicesError, nonFieldErrors, fieldErrors } = formatErrors(reportErrors);
        displayErrorsInToast([backendServicesError, nonFieldErrors]);
        setErrorsToForm(setError, errors, fieldErrors);
        finishLoading(reportErrors);
      }
    }
  };

  return (
    <Popup
      title={TITLE}
      submitButtonText="Download Report"
      toggleState={setPopupState}
      onSubmit={methods.handleSubmit(handleImportSubmit)}
      onClose={handleImportClose}
      isLoading={isTaskReportLoading}
    >
      <FormProvider {...methods}>
        <div className={classes.dateInputWrap}>
          <DatePicker field={formField} />
        </div>
      </FormProvider>
    </Popup>
  );
};

FundingRequestPopup.propTypes = {
  setPopupState: PropTypes.func,
};

export default FundingRequestPopup;
